module.exports = __webpack_public_path__ + "assets/img/dialog-bg@2x.1db17721.png";